import React, { useState } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
const Modal = ({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) => {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm transition-opacity" onClick={onClose} data-id="element-73">
      <div className="bg-[#132038] border border-white/10 rounded-2xl w-full max-w-2xl max-h-[80vh] flex flex-col shadow-2xl overflow-hidden animate-in fade-in zoom-in-95 duration-200" onClick={e => e.stopPropagation()} data-id="element-74">
        <div className="flex items-center justify-between p-6 border-b border-white/10 shrink-0" data-id="element-75">
          <h3 className="text-xl font-bold text-white" data-id="element-76">{title}</h3>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-1 rounded-lg hover:bg-white/5" aria-label="Cerrar" data-id="element-77">
            <XIcon className="w-6 h-6" data-id="element-78" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto text-left text-gray-300 space-y-4 text-sm md:text-base" data-id="element-79">
          {children}
        </div>
      </div>
    </div>;
};
export function Footer() {
  const [isPrivacyOpen, setIsPrivacyOpen] = useState(false);
  const [isTermsOpen, setIsTermsOpen] = useState(false);
  return <footer className="w-full bg-[#0a1628] py-12 px-4" data-id="element-80">
      <div className="max-w-2xl mx-auto text-center" data-id="element-81">
        <p className="text-red-400 font-semibold mb-4" data-id="element-82">⚠️ AVISO IMPORTANTE</p>

        <p className="text-gray-400 text-sm mb-6" data-id="element-83">
          Este producto es educativo e informativo. No reemplaza diagnóstico
          médico ni tratamiento profesional. Si sospechas apnea del sueño,
          depresión severa u otro trastorno, consulta a un profesional de salud.
        </p>

        <div className="border-t border-white/10 my-6" data-id="element-84"></div>

        <p className="text-gray-500 text-sm mb-4" data-id="element-85">
          © 2026 Duermes… Pero No Descansas
          <br data-id="element-86" />
          Todos los derechos reservados.
        </p>

        <div className="flex justify-center items-center gap-4 text-sm" data-id="element-87">
          <button onClick={() => setIsPrivacyOpen(true)} className="text-gray-500 hover:text-white transition-colors" data-id="element-88">
            Política de privacidad
          </button>
          <span className="text-gray-600" data-id="element-89">|</span>
          <button onClick={() => setIsTermsOpen(true)} className="text-gray-500 hover:text-white transition-colors" data-id="element-90">
            Términos de uso
          </button>
        </div>
      </div>

      {/* Privacy Policy Modal */}
      <Modal isOpen={isPrivacyOpen} onClose={() => setIsPrivacyOpen(false)} title="Política de Privacidad" data-id="element-91">
        <p data-id="element-92">
          En <strong data-id="element-93">Duermes… Pero No Descansas</strong>, respetamos tu
          privacidad y estamos comprometidos a proteger tus datos personales.
          Esta política explica cómo recopilamos, usamos y protegemos tu
          información.
        </p>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-94">
          1. Información que recopilamos
        </h4>
        <p data-id="element-95">
          Al adquirir nuestro producto digital, recopilamos información básica
          necesaria para procesar tu pedido, como tu nombre y dirección de
          correo electrónico. Los datos de pago (tarjetas de crédito/débito) son
          procesados de forma segura por proveedores de pago de terceros y
          nosotros no almacenamos esta información en nuestros servidores.
        </p>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-96">
          2. Uso de la información
        </h4>
        <p data-id="element-97">Utilizamos tu correo electrónico exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-98">
          <li data-id="element-99">
            Entregar el producto digital (guía y bonos) que has adquirido.
          </li>
          <li data-id="element-100">Enviar recibos y confirmaciones de compra.</li>
          <li data-id="element-101">
            Proporcionar soporte técnico relacionado con tu acceso al material.
          </li>
        </ul>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-102">
          3. Compartir información con terceros
        </h4>
        <p data-id="element-103">
          No vendemos, alquilamos ni compartimos tus datos personales con
          terceros para fines de marketing. Tu información solo se comparte con
          los procesadores de pago estrictamente necesarios para completar tu
          transacción de forma segura.
        </p>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-104">
          4. Uso de Cookies
        </h4>
        <p data-id="element-105">
          Utilizamos cookies mínimas y estrictamente necesarias para el
          funcionamiento básico del sitio web y analíticas anónimas para
          entender cómo los usuarios interactúan con nuestra página.
        </p>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-106">5. Tus derechos</h4>
        <p data-id="element-107">
          Tienes derecho a solicitar el acceso, la corrección o la eliminación
          de tus datos personales en cualquier momento. Si deseas ejercer estos
          derechos, puedes responder a cualquiera de los correos electrónicos de
          confirmación de tu compra.
        </p>
      </Modal>

      {/* Terms of Use Modal */}
      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Términos de Uso" data-id="element-108">
        <p data-id="element-109">
          Al acceder y adquirir <strong data-id="element-110">Duermes… Pero No Descansas</strong>,
          aceptas estar sujeto a los siguientes términos y condiciones.
        </p>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-111">
          1. Naturaleza del Producto
        </h4>
        <p data-id="element-112">
          Este es un producto digital de carácter estrictamente educativo e
          informativo. El contenido proporcionado no constituye consejo médico,
          diagnóstico ni tratamiento. Nunca debes ignorar el consejo médico
          profesional ni demorar en buscarlo debido a algo que hayas leído en
          este material.
        </p>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-113">
          2. Licencia de Uso
        </h4>
        <p data-id="element-114">
          Al realizar la compra, se te otorga una licencia personal, no
          exclusiva e intransferible para acceder y descargar el material. Queda
          estrictamente prohibida la reproducción, distribución, reventa o
          modificación de cualquier parte de este producto sin autorización
          previa.
        </p>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-115">
          3. Política de Reembolso
        </h4>
        <p data-id="element-116">
          Ofrecemos una garantía de devolución de dinero de 30 días sin
          preguntas. Si no estás satisfecho con el producto, puedes solicitar un
          reembolso completo dentro de los 30 días posteriores a tu compra
          respondiendo al correo de confirmación de tu pedido.
        </p>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-117">
          4. Propiedad Intelectual
        </h4>
        <p data-id="element-118">
          Todo el contenido, diseño, textos, gráficos y estructura de "Duermes…
          Pero No Descansas" son propiedad exclusiva de sus creadores y están
          protegidos por las leyes de derechos de autor y propiedad intelectual
          internacionales.
        </p>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-119">
          5. Limitación de Responsabilidad
        </h4>
        <p data-id="element-120">
          Los creadores de este producto no se hacen responsables por la
          interpretación, aplicación o resultados derivados del uso de la
          información proporcionada. Los resultados pueden variar de persona a
          persona.
        </p>

        <h4 className="text-white font-semibold mt-6 mb-2" data-id="element-121">
          6. Modificaciones
        </h4>
        <p data-id="element-122">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Las modificaciones entrarán en vigor inmediatamente después
          de su publicación en el sitio web.
        </p>
      </Modal>
    </footer>;
}